module.exports = __webpack_public_path__ + "static/media/001.ce64ed82.JPG";